import Menu from './parameter_configuration.vue';

export default Menu;
